import {json, MiniSignal} from "p3";
import common from "../common";
import definitions from "../definitions";
import settings from "../settings";

export default class Ads {

    constructor() {

        this.rewardAd = null;
        this.adLoading = false;
        this.adRequested = false;
        this.adRewarded = false;
        this.loadFailCounter = 0;

        this.signals = {
            viewed: new MiniSignal(),
            fail: new MiniSignal()
        }; 
        if(settings.APP && window.admob) {
            console.log('starting admob');
            admob.start()
                .then(() => {
                    console.log('admob started');
                    admob.configure({
                    testDeviceIds: ['33BE2250B43518CCDA7DE426D04EE231'],
                })})
                .then(() => {
                    this.loadNewAd();
                })
                .then(() =>
                    admob.BannerAd.config({
                    backgroundColor: '#A7A7A7',
                    marginTop: 10,
                    marginBottom: 10,
                    }),
                )
        }
    }

    isAdEnabled(id) {
        return settings.APP && json('ads')[id] && (this.rewardAd || this.adLoading || this.loadHasFailed);
    }

    loadNewAd() {
        console.log('load admob ad');
        this.rewardAd = null;
        this.adLoading = true;
        const rewardAd = new admob.RewardedAd({
            //adUnitId: 'ca-app-pub-3940256099942544/5224354917',
            adUnitId: '/99911224/cn_app/cn_ivandoe',
        });
        rewardAd.on('load', (evt) => {
            console.log('admob loaded');
            this.rewardAd = rewardAd;
            this.adLoading = false;
            if (this.adRequested) {
                console.log('showing requested admob');
                this.adRequested = false;
                this.adRewarded = false;
                this.rewardAd.show();
            }
        });
        rewardAd.on('reward', this.onAdRewarded.bind(this));
        rewardAd.on('dismiss', this.onAdViewed.bind(this));
        rewardAd.on('loadfail', this.onLoadFail.bind(this));
        rewardAd.on('showfail', this.onShowFail.bind(this));
        rewardAd.load();
    }

    showAd() {
        console.log('requested show admob');
        if (this.rewardAd) {
            console.log('admob show');
            this.adRewarded = false;
            this.rewardAd.show();
            return true;
        } else if(this.adLoading) {
            console.log('admob still loading');
            this.adRequested = true;
            return true;
        } else if(this.loadHasFailed) {
            this.loadFailCounter = 0;
            this.adRequested = true;
            this.loadNewAd();
            return true;
        }
        return false;
    }

    onAdRewarded() {
        console.log('admob rewarded');
        this.adRewarded = true;
    }

    onAdViewed() {
        console.log('admob viewed');
        this.signals.viewed.dispatch(this.adRewarded);
        this.adRewarded = false;
        this.loadNewAd();
    }

    onLoadFail(e) {
        this.loadFailCounter ++;
        if (!this.loadHasFailed) {
            this.loadNewAd();
        } else {
            this.signals.fail.dispatch();
            this.adLoading = false;
            this.adRequested = false;
        }
    }

    onShowFail(e) {
        this.signals.fail.dispatch();
    }

    get loadHasFailed() {
        return this.loadFailCounter >= 5;
    }
}